export const contactUsIssues = {
  option0: 'Get buying advice',
  option1: 'Try a Which? product or service',
  option2: 'See how our experts can help',
  option3: 'Request help logging in',
  option4: 'Update your email or postal address',
  option5: 'GDPR & privacy-related request',
}
